import { Concert } from "../interfaces/interfaces";
// use ISO format for dates to sort by newest effectievely: YYYY-MM-DD
export const upcomingConcerts: Concert[] = [
  {
    id: 1,
    title: "Duplessy et les violons du monde - Fesival le rêve de l'Aborigène",
    date: "26 Juillet 2025",
    location: "Deux Sèvres, France",
  },
  {
    id: 2,
    title: "Festival Musique au Logis",
    date: "31 Juillet 2025",
    location: "Montréverd, France",
  },

  {
    id: 3,
    title: "Festival du Bout du Monde",
    date: "2 Août 2025",
    location: "Crozon France"
  },
  {
    id: 4,
    title: "Festival Symphonique d'été",
    date: "5 Août 2025",
    location: "Fouras, France",
  },
  {
    id: 5,
    title: "Imagine, Festival International de Carthage",
    date: "8 Août 2025",
    location: "Carthage, Tunisie",
  },
  {
    id: 6,
    title: "Festival International des Musiques Sacrées",
    date: "10 Août 2025",
    location: "Sylvanes, France",
  },
];